import { useState, useCallback } from 'react';

/**
 * Custom hook to manage view state for drilling down from subid2 to subid3
 */
const useViewState = () => {
  const [isSubid3View, setIsSubid3View] = useState(false);
  const [selectedSubid2, setSelectedSubid2] = useState(null);
  const [platformType, setPlatformType] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([{ label: 'All Campaigns', value: null }]);
  const [viewTransitioning, setViewTransitioning] = useState(false);
  
  // Function to enter subid3 view (drill down)
  const enterSubid3View = useCallback((subid2, platform = null) => {
    console.log(`Entering subid3 view for ${subid2}, platform: ${platform || 'unknown'}`);
    
    // Prevent concurrent transitions
    setViewTransitioning(true);
    
    // Update state values all at once
    setIsSubid3View(true);
    setSelectedSubid2(subid2);
    setPlatformType(platform);
    setBreadcrumbs([
      { label: 'All Campaigns', value: null },
      { label: subid2, value: subid2 }
    ]);
    
    // Clear transition state after a delay
    setTimeout(() => {
      setViewTransitioning(false);
    }, 300);
  }, []);
  
  // Function to return to subid2 view
  const returnToSubid2View = useCallback(() => {
    console.log('Returning to subid2 view');
    
    // Prevent concurrent transitions
    setViewTransitioning(true);
    
    // Clear state completely
    setIsSubid3View(false);
    setSelectedSubid2(null);
    setPlatformType(null);
    setBreadcrumbs([{ label: 'All Campaigns', value: null }]);
    
    // Clear transition state after a delay
    setTimeout(() => {
      setViewTransitioning(false);
    }, 300);
  }, []);
  
  return {
    isSubid3View,
    selectedSubid2,
    platformType,
    breadcrumbs,
    viewTransitioning,
    enterSubid3View,
    returnToSubid2View
  };
};

export default useViewState; 